const seSpeakText = "_seSpeakText_10bkr_10";
const styles = {
	seSpeakText: seSpeakText
};

export { styles as default, seSpeakText };
//# sourceMappingURL=render-element.module.css.js.map
